import React from "react";
import { IMAGE_URL } from "../../constants";

const ResearchAndTraining = ({ cards }) => {
  console.log("your log output", cards);

  return (
    <div className="container">
      {cards.map((section, index) => (
        <div
          key={section.id}
          className="row mb-5 align-items-center justify-content-between h-100"
        >
          {/* First Column */}
          <div
            className={`col-3 p-0 d-flex align-items-end h-100`}
            style={{ height: "100%" }}
          >
            {/* <div className="col-3"> */}
            {index % 2 === 0 ? (
              section.media[0] && (
                <img
                  style={{ borderRadius: "10px" }}
                  src={`${IMAGE_URL}${section.media[0]}`}
                  alt="First Column Image"
                  className="w-100"
                />
              )
            ) : (
              <div></div> // Empty column for odd-indexed sections
            )}
          </div>

          {/* Second Column */}
          <div className="col-3 text-center p-0">
            {index % 2 === 0 ? (
              <h4 className="jci-heading">{section.title}</h4>
            ) : (
              section.media[0] && (
                <img
                  style={{ borderRadius: "10px" }}
                  src={`${IMAGE_URL}${section.media[0]}`}
                  alt="Second Column Image"
                  className="img-fluid w-100"
                />
              )
            )}
          </div>

          {/* Third Column */}
          <div className="col-3 text-center p-0">
            {index % 2 === 0 ? (
              section.media[1] && (
                <img
                  src={`${IMAGE_URL}${section.media[1]}`}
                  alt="Third Column Image"
                  className="img-fluid w-100"
                  style={{ borderRadius: "10px" }} // Bigger image
                />
              )
            ) : (
              <h4 className="jci-heading">{section.title}</h4>
            )}
          </div>

          {/* Fourth Column */}
          <div className={`col-3 d-flex justify-content-end p-0`}>
            {index % 2 === 0 ? (
              <div></div> // Empty column for even-indexed sections
            ) : (
              section.media[1] && (
                <img
                  src={`${IMAGE_URL}${section.media[1]}`}
                  alt="Fourth Column Image"
                  className="img-fluid w-100"
                  style={{ borderRadius: "10px" }} // Bigger image
                />
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResearchAndTraining;



// WEBPACK FOOTER //
// ./src/component/frontend/ResearchAndTraining.js